import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import PowerBILoader from "./PowerBILoader";
import { BACK_END_API_URL, FRONT_END_DOMAIN, REPORT_IDs } from "../../utils/LS-CONSTANT";
import LS_API from "../../api/axios";

// Get access token helper
const getAccessToken = () => {
  const match = document.cookie.match(/(^| )access_token=([^;]+)/);
  if (match) return match[2];

  const cognitoKey = Object.keys(localStorage).find(
    (k) =>
      k.startsWith("CognitoIdentityServiceProvider.") &&
      k.endsWith(".accessToken")
  );
  if (cognitoKey) return localStorage.getItem(cognitoKey);

  return null;
};

// Map URL param to reportId
const reportIdMap = {
  ccmr: REPORT_IDs.ccmr,
  dq: REPORT_IDs.dq,
  "ccmr-sla": REPORT_IDs["ccmr-sla"]
};


const PowerBIReport = () => {
  const { report } = useParams();
  const [embedConfig, setEmbedConfig] = useState(null);

  const activeReportId = reportIdMap[report];

  useEffect(() => {
    if (!activeReportId) return;

    const loadReport = async () => {
      try {
        const token = getAccessToken();
        if (!token) return;

        const res = await LS_API.get(`/api/report/embed?reportId=${activeReportId}`);
        const { embedReports, embedToken } = res.data;

        if (!embedReports || embedReports.length === 0) return;

        const { embedUrl, reportId: id } = embedReports[0];

        setEmbedConfig({
          type: "report",
          id,
          embedUrl,
          accessToken: embedToken,
          tokenType: models.TokenType.Embed,
          settings: {
            localeSettings: { language: "en", formatLocale: "en-US" },
            panes: {
              filters: { visible: false },
              pageNavigation: { visible: true },
            },
            layoutType: models.LayoutType.Custom,
            customLayout: {
              displayOption: models.DisplayOption.FitToWidth,
              reportAlignment: models.ReportAlignment.Center,
              pagesLayout: {},
            },
            background: models.BackgroundType.Transparent,
          },
        });
      } catch (err) {
        console.error("Failed to load report:", err);
      }
    };

    loadReport();
  }, [activeReportId]);


  return embedConfig ? (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PowerBIEmbed
        embedConfig={embedConfig}
        cssClassName="powerbi-report"
        getEmbeddedComponent={(embeddedReport) => { }}
      />
    </div>
  ) : (
    <PowerBILoader />
  );

};

export default PowerBIReport;

